"use client";

// Small shared chart pieces: legend chips (the step-2 Badge primitive's
// neutral chip + raw-color dot pairing) and a token-styled tooltip.

import { Badge } from "@/app/components/ui/badge";

export function LegendChip({ label, color }: { label: string; color: string }) {
  return (
    <Badge color={color} dot>
      {label}
    </Badge>
  );
}

export function ChartTooltip({
  active,
  payload,
  label,
}: {
  active?: boolean;
  payload?: { name?: string; value?: number | string }[];
  label?: string;
}) {
  if (!active || !payload?.length) return null;

  return (
    <div className="rounded-md border border-border bg-card px-3 py-2 text-xs">
      <p className="text-muted-foreground">{label}</p>
      {payload.map((item) => (
        <p key={item.name} className="mt-0.5 font-medium text-foreground">
          {item.name}: {item.value}
        </p>
      ))}
    </div>
  );
}
